import { render, staticRenderFns } from "./tabComponent.vue?vue&type=template&id=0febb168&"
import script from "./tabComponent.vue?vue&type=script&lang=js&"
export * from "./tabComponent.vue?vue&type=script&lang=js&"
import style0 from "./tabComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports